import { Bell, BellOff, Building2, Check, CheckCircle2, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { DELIVERY_LABELS, durationBetween, durationSince, formatDateTime } from "../lib/format";
import type { ProblemListItem } from "../types";
import { Button, EmptyState, SeverityBadge } from "./ui";

export function ProblemList({ problems, onAcknowledge, acknowledgingId, compact = false, emptyTitle = "No hay problemas para mostrar", emptyDescription = "Los nuevos eventos aparecerán acá cuando el monitoreo los detecte." }: {
  problems: ProblemListItem[];
  onAcknowledge?: (problem: ProblemListItem) => void;
  acknowledgingId?: string | null;
  compact?: boolean;
  emptyTitle?: string;
  emptyDescription?: string;
}) {
  if (problems.length === 0) {
    return <EmptyState icon={BellOff} title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <div className={`problem-list${compact ? " problem-list--compact" : ""}`}>
      {problems.map((problem) => (
        <article className={`problem-row problem-row--${problem.severity}`} key={problem.id}>
          <div className="problem-row__severity"><SeverityBadge severity={problem.severity} /></div>
          <div className="problem-row__body">
            <h3><Link to={`/problemas/${problem.id}`}>{problem.name}</Link></h3>
            <div className="problem-row__meta">
              <span><Building2 size={14} aria-hidden="true" /> {problem.building?.name ?? "Monitoreo general"}</span>
              {problem.building?.client ? <span>{problem.building.client.name}{problem.building.region ? ` · ${problem.building.region.name}` : ""}</span> : null}
              {problem.status === "recovered" && problem.recoveredAt ? (
                <><span className="problem-state problem-state--recovered"><CheckCircle2 size={14} aria-hidden="true" /> Recuperado {formatDateTime(problem.recoveredAt)}</span><span>Duró {durationBetween(problem.startedAt, problem.recoveredAt)}</span></>
              ) : problem.status === "suppressed" ? (
                <span className="problem-state problem-state--suppressed"><BellOff size={14} aria-hidden="true" /> Suprimido · comenzó {formatDateTime(problem.startedAt)}</span>
              ) : (
                <span>Activo hace {durationSince(problem.startedAt)}</span>
              )}
              <span><Bell size={14} aria-hidden="true" /> {problem.notificationStatus && problem.notificationStatus !== "not_routed" ? DELIVERY_LABELS[problem.notificationStatus] : "Sin envío inmediato"}</span>
              {problem.acknowledgedAt ? <span className="acknowledged"><Check size={14} aria-hidden="true" /> Atendido</span> : null}
            </div>
          </div>
          <div className="problem-row__actions">
            {onAcknowledge && problem.alertId && !problem.acknowledgedAt && problem.status === "open" ? (
              <Button variant="secondary" size="small" aria-label={`Marcar atendido: ${problem.name}`} loading={acknowledgingId === problem.id} onClick={() => onAcknowledge(problem)}>
                <Check size={15} aria-hidden="true" /> <span className="button__label">Marcar atendido</span>
              </Button>
            ) : null}
            <Link className="icon-button" aria-label={`Ver detalle de ${problem.name}`} to={`/problemas/${problem.id}`}><ChevronRight size={18} /></Link>
          </div>
        </article>
      ))}
    </div>
  );
}
